import { useTranslation } from 'react-i18next';

export default function Spinner({ label }) {
    const { t } = useTranslation();
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--text)', padding: '1rem 0' }}>
            <span className="spinner" />
            <span>{label ?? t('common.loading')}</span>
        </div>
    );
}
